import React, { useState } from 'react';
import styles from './styles.scss';
import IframeDialog from '../../../atoms/iframe-dialog/IframeDialog';

interface AllCommentsModalProps {
    isMobile: boolean;
    targetKey: string;
    charityKey: string;
}

const AllCommentsModal = function AllCommentsModal({ isMobile = false, targetKey, charityKey }: AllCommentsModalProps) {
    const [show, setShow] = useState(false);

    return (
        <>
            <div className={styles['view-all-positioner']}>
                <span
                    role="button"
                    tabIndex={0}
                    className={styles['view-all-text']}
                    onClick={() => setShow(true)}
                >
                    View all
                    <span>
                        <svg width="35" height="35" viewBox="0 0 45 35" fill="grey" xmlns="http://www.w3.org/2000/svg">
                            <path transform="translate(6, 5.374)" d="M18.629 15.997l-7.083-7.081L13.462 7l8.997 8.997L13.457 25l-1.916-1.916z" />
                        </svg>
                    </span>
                </span>
            </div>
            {show && (
                <IframeDialog
                    clickHandler={(shouldShow: boolean) => setShow(shouldShow)}
                    paperPropsStyle={isMobile
                        ? {
                            minWidth: '100%', height: '80%', backgroundColor: '#F2F2F2',
                        }
                        : {
                            minWidth: '80%', height: '80%', backgroundColor: '#F2F2F2',
                        }}
                    isMobile={isMobile}
                    hideScroller
                    content={(
                        <iframe
                            id="iframe_id"
                            src={`/Campaigns/Comments?targetKey=${targetKey}&charityKey=${charityKey}`}
                            title="Iframe Dialog"
                            style={{
                                overflow: 'hidden',
                                height: '100%',
                                minWidth: isMobile ? '106%' : '102%',
                            }}
                        />
                    )}
                />
            )}
        </>
    );
};

export default AllCommentsModal;